<template>
  <div>
    <Button
      style="margin-bottom: 20px;"
      type="primary"
      @click="addDataRowAuthOpeationBtnClick"
      >操作录入</Button
    >
    <Table
      class="dataAuthTable"
      border
      :columns="dataRowAuthColumns"
      size="small"
      stripe
      :data="dataRowAuthDataSource"
      disabled-hover
      row-key="id"
      ref="dataAuthtableRef"
    >
    </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          show-total
          show-sizer
          :total="dataRowAuthCount"
          :current="RowFilter.pageIndex"
          :page-size="RowFilter.pageSize"
          :page-size-opts="[5, 10, 15, 20]"
          @on-change="dataRowAuthChangePage"
          @on-page-size-change="dataRowAuthSizeChange"
        ></Page>
      </div>
    </div>
    <!-- 数据行权限表单 -->
    <Modal v-model="dataRowAuthFormDisplayStatus" title="操作录入">
      <Form
        label-position="left"
        :label-width="100"
        :model="dataRowAuthValidate"
        ref="dataRowAuthValidate"
        :rules="dataRowAuthRuleValidate"
      >
        <FormItem label="规则名称:" prop="ruleName">
          <Input
            placeholder="请输入规则名称"
            v-model="dataRowAuthValidate.ruleName"
          ></Input>
        </FormItem>
        <FormItem label="规则字段:" prop="ruleField">
          <Input
            placeholder="请输入规则字段"
            v-model="dataRowAuthValidate.ruleField"
          ></Input>
        </FormItem>
        <FormItem label="规则条件:" prop="ruleCondition">
          <Select v-model="dataRowAuthValidate.ruleCondition">
            <Option
              v-for="item in authRuleList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="规则值:" prop="ruleVal">
          <Input
            placeholder="请输入规则值"
            v-model="dataRowAuthValidate.ruleVal"
          ></Input>
        </FormItem>
        <FormItem label="表名称:" prop="tableName">
          <Input
            placeholder="请输入表名称"
            v-model="dataRowAuthValidate.tableName"
          ></Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="dataRowHandleSubmit('dataRowAuthValidate')"
            >确认</Button
          >
          <Button @click="popDataRowMoal" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
  </div>
</template>

<script>
// import getPermissionMixin from '@/mixins/getPermissionMixin';
import { mapActions, mapMutations, mapState } from 'vuex';
import { getDataRowAuthColumns } from '../config';

const addRowRuleURL = '/v1/funcMenu/dataRowRule';
export default {
  props: {
    selectedMenuObj: {
      type: Object,
      default: {}
    },
    currentSystem: {
      type: String,
      default: ''
    }
  },
  // mixins: [getPermissionMixin],
  watch: {
    selectedMenuObj: {
      deep: true,
      handler(newValue, oldValue) {
        this.refreshDataRowAuth();
      }
    }
  },
  computed: {
    ...mapState('menuManage', ['dataRowAuthDataSource', 'dataRowAuthCount'])
  },
  data() {
    const ruleFieldCheck = (rule, value, callback) => {
      if (value === '' && this.dataRowAuthValidate.ruleCondition != '自定义') {
        callback(new Error('请填写规则字段'));
      } else {
        callback();
      }
    };
    return {
      dataRowAuthFormDisplayStatus: false,
      // 当前操作的对象
      currentOperateObj: '',
      authRuleList: [
        { label: '大于', value: '大于' },
        { label: '大于等于', value: '大于等于' },
        { label: '小于', value: '小于' },
        { label: '小于等于', value: '小于等于' },
        { label: '等于', value: '等于' },
        { label: '包含', value: '包含' },
        { label: '模糊', value: '模糊' },
        { label: '不等于', value: '不等于' },
        { label: '自定义', value: '自定义' }
      ],
      RowFilter: {
        pageIndex: 1,
        pageSize: 10
      },
      dataRowAuthRuleValidate: {
        ruleCondition: [
          { required: true, message: '规则条件未填写', trigger: 'blur' }
        ],
        ruleField: [
          {
            validator: ruleFieldCheck,
            trigger: 'blur'
          }
        ],
        ruleName: [
          { required: true, message: '规则名称未填写', trigger: 'blur' }
        ],
        ruleVal: [{ required: true, message: '规则值未填写', trigger: 'blur' }]
      },
      dataRowAuthValidate: {
        appId: '',
        funcMenuId: '',
        ruleCondition: '',
        ruleField: '',
        ruleName: '',
        ruleVal: '',
        tableName: ''
      },
      dataRowAuthColumns: getDataRowAuthColumns(
        this.deleteDataRowAuthBtnClick,
        this.editDataRowAuthBtnClickBtnClick
      )
    };
  },
  methods: {
    ...mapMutations('menuManage', ['SAVE_STATE']),
    ...mapActions('menuManage', ['getUserPermission', 'getDataRowAuthList']),
    popDataRowMoal() {
      this.dataRowAuthFormDisplayStatus = false;
    },
    addDataRowAuthOpeationBtnClick() {
      this.rowOpterate = 0;
      this.clearRowForm();
      this.dataRowAuthFormDisplayStatus = true;
    },
    dataRowAuthChangePage(num) {
      this.RowFilter.pageIndex = num;
      this.getDataRowAuthList({
        funcMenuId: this.selectedMenuObj.id,
        RowFilter: this.RowFilter
      });
    },
    dataRowAuthSizeChange(size) {
      this.RowFilter.pageSize = size;
      this.getDataRowAuthList({
        funcMenuId: this.selectedMenuObj.id,
        RowFilter: this.RowFilter
      });
    },
    clearRowForm() {
      this.dataRowAuthValidate.ruleCondition = '';
      this.dataRowAuthValidate.ruleField = '';
      this.dataRowAuthValidate.ruleName = '';
      this.dataRowAuthValidate.ruleVal = '';
      this.dataRowAuthValidate.tableName = '';
    },
    deleteDataRowAuthBtnClick(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否删除该菜单？',
        loading: true,
        cancelText: '取消',
        onOk: () => {
          this.$ajax.delete(`${addRowRuleURL}/${row.id}`).then(res => {
            const { data } = res;
            if (data.code == 200) {
              this.$Message.success(data.msg);
              this.$Modal.remove();
              this.refreshDataRowAuth();
            } else {
              this.$Message.error(data.msg);
            }
          });
        }
      });
    },
    editDataRowAuthBtnClickBtnClick(row) {
      this.rowOpterate = 1;
      this.dataRowAuthFormDisplayStatus = true;
      this.currentOperateObj = row;
      this.dataRowAuthValidate.ruleCondition = row.ruleCondition;
      this.dataRowAuthValidate.ruleField = row.ruleField;
      this.dataRowAuthValidate.ruleName = row.ruleName;
      this.dataRowAuthValidate.ruleVal = row.ruleVal;
      this.dataRowAuthValidate.tableName = row.tableName;
    },
    refreshDataRowAuth() {
      this.RowFilter = {
        pageIndex: 1,
        pageSize: 10
      };
      this.getDataRowAuthList({
        funcMenuId: this.selectedMenuObj.id,
        RowFilter: this.RowFilter
      });
    },
    dataRowHandleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.dataRowAuthValidate.appId = this.currentSystem;
          this.dataRowAuthValidate.funcMenuId = this.selectedMenuObj.id;
          const params = this.dataRowAuthValidate;
          if (this.rowOpterate == 0) {
            // 新增
            this.$ajax.post(addRowRuleURL, params).then(res => {
              if (res.data.code == 200) {
                this.$Message.success(res.data.msg);
                this.dataRowAuthFormDisplayStatus = false;
                this.refreshDataRowAuth();
              } else {
                this.$Message.error(res.data.msg);
              }
            });
          } else {
            // 编辑
            this.$ajax
              .put(`${addRowRuleURL}/${this.currentOperateObj.id}`, params)
              .then(res => {
                if (res.data.code == 200) {
                  this.$Message.success(res.data.msg);
                  this.dataRowAuthFormDisplayStatus = false;
                  this.refreshDataRowAuth();
                } else {
                  this.$Message.error(res.data.msg);
                }
              });
          }
        } else {
          this.$Message.error('所填信息异常');
        }
      });
    }
  }
};
</script>

<style></style>
